import { Link } from "react-router";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import IconFactory from "@components/Icon/IconFactory";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";
import { TrackingObjectCustomEvent } from "@features/analytics/utils/types";
import { useWindowSize } from "@hooks/useWindowSize";
import { PODCASTS_SUBSCRIBERS } from "@routes/Article/utils/constants";
import { PodcastsExternalLinksType } from "@routes/Article/utils/types";
import { cn } from "@util/helpers";

type PodcastSubscriptionsComponentProps = {
  link: PodcastsExternalLinksType;
  tagName: string;
};

/**
 * Component for Podcast Article Subscriptions.
 */
const PodcastSubscriptionsComponent = ({
  link: { title, link },
  tagName,
}: PodcastSubscriptionsComponentProps): React.ReactElement => {
  const { isScreenLG } = useWindowSize();
  const sendDataToGTM = useSendDataToGTM();

  const handleOnClickSendData = () => {
    if (typeof window === "undefined") return;

    const trackingObject: TrackingObjectCustomEvent = {
      event: "custom_event",
      eventCategory: "podcast",
      eventAction: "subscribe::" + title.toLowerCase(),
      eventLabel: tagName.toLowerCase(),
    };

    sendDataToGTM(trackingObject);
  };

  if (isScreenLG) {
    return (
      <Link
        key={title}
        to={link}
        onClick={handleOnClickSendData}
        target="_blank"
        className="px-2 text-base font-semibold text-gray-175"
        rel="noreferrer"
      >
        {title}
      </Link>
    );
  }

  return (
    <ButtonFactory
      buttonType={ButtonType.Link}
      link={link}
      mask={ButtonType.Secondary}
      key={link}
      className="border-0 p-0"
      onClick={handleOnClickSendData}
      icon={
        <IconFactory
          type={PODCASTS_SUBSCRIBERS[title]}
          size={24}
          className={cn("text-white", {
            "mb-1": title === "YouTube",
          })}
        />
      }
      iconPosition="left"
    />
  );
};

export default PodcastSubscriptionsComponent;
